export default Object.freeze({
  Pending: 1,
  Submited: 2,
  Approved: 3,
  Denied: 4,
  ConditionalApproved: 5,
  ReplacementRequest: 6,
});
